import { render, staticRenderFns } from "./EducationPlansGrid.vue?vue&type=template&id=ce362186"
import script from "./EducationPlansGrid.vue?vue&type=script&lang=js"
export * from "./EducationPlansGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports